import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

// Shown where the API answers 402: the feature is part of SHUWA Pro.
export default function ProUpgradeNotice({ feature }) {
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-2xl border border-primary/30 bg-primary/5 p-4 text-sm text-slate-700">
      <Sparkles className="h-5 w-5 shrink-0 text-primary" aria-hidden="true" />
      <p className="flex-1">{feature} are part of SHUWA Pro (12,000 RWF / month or 3,500 RWF / week, 6 staff included).</p>
      <Link
        to="/business/subscription"
        className="rounded-full bg-primary px-4 py-2 text-sm font-semibold text-white hover:bg-primary/90"
      >
        Upgrade to Pro
      </Link>
    </div>
  );
}
